import NamingConvention from "../model/NamingConvention";

import { uppercaseFirst, lowercaseFirst } from "./string";

function joinTokens(components: string[], namingConvention: NamingConvention): string {
    if (namingConvention === NamingConvention.CamelCase || namingConvention === NamingConvention.UpperCamelCase) {
        const name = components.map(uppercaseFirst).join("");
        return namingConvention === NamingConvention.CamelCase ? lowercaseFirst(name) : name;
    } else if (namingConvention === NamingConvention.SnakeCase) {
        return components.join("_");
    }

    return components.join("-");
}

const tokenizer = /\d+|[a-z]+|[A-Z]+(?![a-z])|[A-Z][a-z]+/g;

function tokensForString(str: string): string[] {
    const matchResult = str.match(tokenizer);
    if (!matchResult) {
        return ["invalid", "name"];
    }

    return matchResult.map(token => token.toLowerCase());
}

export default function (name: string, namingConvention: NamingConvention): string {
    return joinTokens(tokensForString(name), namingConvention);
}
